import { ThemeProvider, createTheme } from "@mui/material/styles";
import { themeOptions } from "./theme/theme";
import CssBaseline from "@mui/material/CssBaseline";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/common/layout/layout";
import LayoutLanding from "./components/common/layout/layout-landing";
import Home from "./components/home/home";
import Landing from "./components/landing/landing";
import NoMatch from "./components/no-match/no-match";
import Info from "./components/info/info";
import StageTimes from "./components/stage-times/stage-times";
import LineUp from "./components/line-up/line-up";
import Food from "./components/food/food";

import "./App.css";

import "./fonts/itc-busorama-bold.otf";

function App() {
  const theme = createTheme(themeOptions);
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <CssBaseline />
        <Routes>
          <Route path="/" element={<LayoutLanding />}>
            <Route index element={<Landing />} />
            <Route path="*" element={<NoMatch />} />
          </Route>
          <Route path="/2026" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="line-up" element={<LineUp />} />
            <Route path="food" element={<Food />} />
            <Route path="info" element={<Info />} />
            <Route path="stage-times" element={<StageTimes />} />
            <Route path="*" element={<NoMatch />} />
          </Route>
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
